
class HomeController {
  constructor(ClientService, AuthService, $scope, $state) {
    "ngInject";
    this.name = 'home';
    this.clientService = ClientService;
    this.authService = AuthService;
    this.scope = $scope;
    this.state = $state;
    this.applications = [];
  }

  $onInit() {
    //Hdd to do this here since webpack was giving me an issue in css
    $('.app').css('background-image', 'url("assets/app/lot_bg.png")')
    .css('background-repeat', 'no-repeat')
    .css('background-size', 'cover')
    .css('background-position', 'center');

    $('.footer').removeClass('bg-white');  //so the image expands full screen

    this.applications = this.authService.getAppAccess();
  }

  goToApp(url) {
    window.location=url;
  }

}
export default HomeController;





// WEBPACK FOOTER //
// ./client/app/components/home/home.controller.js